import * as betgalaxy from './Footer.styles.betgalaxy';
import * as betprofessor from './Footer.styles.betprofessor';
import * as betroyale from './Footer.styles.betroyale';
import * as fiestabet from './Footer.styles.fiestabet';
import * as goldenrush from './Footer.styles.goldenrush';
import * as juicybet from './Footer.styles.juicybet';
import * as puntgenie from './Footer.styles.puntgenie';
import * as questbet from './Footer.styles.questbet';
import * as sterlingparker from './Footer.styles.sterlingparker';
import * as vikingbet from './Footer.styles.vikingbet';
import * as volcanobet from './Footer.styles.volcanobet';
import * as wellbet from './Footer.styles.wellbet';
import * as forsport from './Footer.styles.forsport';
import * as puntcity from './Footer.styles.puntcity';
import * as junglebet from './Footer.styles.junglebet';
import * as oldgill from './Footer.styles.oldgill';
import * as buffalobet from './Footer.styles.buffalobet';
import * as titanbet from './Footer.styles.titanbet';
import * as slambet from './Footer.styles.slambet';
import * as gigabet from './Footer.styles.gigabet';
import * as betstride from './Footer.styles.betstride';
import * as sugarcastle from './Footer.styles.sugarcastle';
import * as templebet from './Footer.styles.templebet';
import * as goldenbet888 from './Footer.styles.goldenbet888';
import * as hyperbet from './Footer.styles.hyperbet';
import * as bet777 from './Footer.styles.bet777';
import * as chromabet from './Footer.styles.chromabet';
import * as bet575 from './Footer.styles.bet575';
import * as epicodds from './Footer.styles.epicodds';
import * as pyramidbet from './Footer.styles.pyramidbet';
import * as magnumbet from './Footer.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  puntcity,
  junglebet,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  sugarcastle,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
